import React from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedReport, loadPowerBIEmbedUrlRequest } from '../redux/Actions';
import { buildEmbedPayload, getEmployeeInfo, getPowerBIEmployeeInfo, getReportIcon } from '../helpers/reportHelpers';
import FavoriteCard from './FavoriteCard';

const ReportsHomePage = ({ favoriteReports, lastViewedReport }) => {
  const dispatch = useDispatch();

  const handleReportClick = (report) => {
    const empInfo = getEmployeeInfo();
    const biEmpInfo = getPowerBIEmployeeInfo();

    // Set selected report
    dispatch(setSelectedReport(report));

    // Build and dispatch embed payload
    const embedPayload = buildEmbedPayload(report, empInfo, biEmpInfo);
    dispatch(loadPowerBIEmbedUrlRequest(embedPayload));
  };

  return (
    <div className="reports-home-page">
      {/* Header Section */}
      <div className="home-header">
        <h1 className="home-title">Reports Portal</h1>        
      </div>

      {/* Continue Where You Left Off Section */}
      {lastViewedReport.length > 0 && (
        <div className="continue-section">
          <h2 className="section-header">CONTINUE WHERE YOU LEFT OFF</h2>
          <div
            className="last-viewed-card"
            onClick={() => handleReportClick(lastViewedReport[0])}
          >
            <div className="last-viewed-icon">
              <i className={`fa fa-${getReportIcon(lastViewedReport[0])}`}></i>
            </div>
            <div className="last-viewed-content">
              <span className="last-viewed-label">LAST VIEWED</span>
              <h3 className="last-viewed-title">{lastViewedReport[0].name}</h3>
              <p className="last-viewed-time">
                {lastViewedReport[0].last_viewed_on
                  ? new Date(lastViewedReport[0].last_viewed_on).toLocaleString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: true
                    })
                  : 'Recently viewed'}
              </p>
            </div>
            <div className="last-viewed-arrow">
              <i className="fa fa-arrow-right"></i>
            </div>
          </div>
        </div>
      )}

      {/* Favorites Section */}
      {favoriteReports.length > 0 && (
        <div className="favorites-home-section">
          <div className="favorites-home-header">
            <i className="fa fa-star"></i>
            <span>FAVORITES</span>
            <span className="favorites-count">{favoriteReports.length}</span>
          </div>
          <div className="favorites-grid">
            {favoriteReports.map((report) => (
              <FavoriteCard
                key={report.id}
                report={report}
                onReportClick={handleReportClick}
              />
            ))}
          </div>
        </div>
      )}

      {/* No Content Empty State */}
      {favoriteReports.length === 0 && lastViewedReport.length === 0 && (
        <div className="no-favorites">
          <i className="fa fa-star-o"></i>
          <p>No favorite reports yet. Click the star icon on any report to add it to favorites.</p>
        </div>
      )}
    </div>
  );
};

export default ReportsHomePage;
